import { createFileRoute } from '@tanstack/react-router'

import { EdgeRoute } from '@/pages/rewards/route-entries/edge'
import { buildPageTitle } from '@/utils/seo'

export const Route = createFileRoute('/_layout/_private/app/rewards/edge')({
  component: EdgeRoute,
  head: () => {
    return {
      meta: [
        {
          title: buildPageTitle('Redeem Edge'),
        },
      ],
    }
  },
})
